import React from 'react';
import { Button, Result } from 'antd';
import { useRouteError, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ErrorPage({ customMessage }) {
  const navigate = useNavigate();
  const error = useRouteError();

  const { t } = useTranslation();

  // Convert status to a valid value for the Result component
  const getValidStatus = (status) => {
    // Valid status values: 403, 404, 500, 'success', 'error', 'info', 'warning'
    if (status === 403 || status === 404 || status === 500 || 
        status === '403' || status === '404' || status === '500' ||
        ['success', 'error', 'info', 'warning'].includes(status)) {
      return status;
    }
    // Default to 'error' for any other status
    return 'error';
  };

  return (
    <Result
      status={customMessage ? '403' : getValidStatus(error?.status)}
      title={customMessage ?? t('error_page.message')}
      subTitle={
        customMessage
          ? t('no_permission')
          : error?.status
            ? `${error?.status} - ${error?.statusText || error?.message}`
            : ''
      }
      extra={
        <Button onClick={() => navigate(-1)} type='primary'>
          {t('error_page.back_home')}
        </Button>
      }
      style={{ marginTop: '5%' }}
    />
  );
}
